export enum Locales {
  RO = 'ro'
}